import React from 'react';
import { Content } from './shared';

const BcbsVitamixBlender = () => (
  <Content>
    Visit the Vitamix website, choose your blender, and use code <i>ASHEALTHVITA1418</i> at
    checkout.
  </Content>
);

export default BcbsVitamixBlender;
